<template>
  <strong>{{ (page - 1) * size + 1 + index }}</strong>
</template>
<script>
export default {
  props: ["page", "size", "index"],
};
</script>